import React from 'react';
import "./styles.css";
/**
 * @function WidgetHeaderView 
 * @param {STRING} scrollClassName - Allows us to add a class to control styles of the header when scrolling. 
 * @param {STRING} Title - A title that we can pass to the widget header view.
 * @param {React.Component} children - React components that's being wrapped by the widget header view.
 * @returns {React.Component}
 * @example
 * <WidgetHeaderView Title="Some Title">
 *  <Link to="/" className="some-class">Link Name</Link>
 * </WidgetHeaderView>
 */
export default function WidgetHeaderView(props) {
  // the className to show correct styles is .scrolling-header
  const scrollClassName = props.scrollClassName ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  return(
    <div className={`widget-header-view-container ${scrollClassName}`}>
      <div className="flex-container flex-horizontal align-center">
        <div className="flex-width">
          <h2 className="widget-title">
            <span { ...dataPoint }>{props.title}</span>
          </h2>
        </div>
        {props.children && (<div className="flex-width text-right justify-right right-column">{props.children}</div>)}
      </div>
    </div>
  );
}